import {
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useAuth } from "../data/providers/AuthProvider";

const GREEN = "#00C853";
const DARK = "#0D1420";

export const YellowBar = () => {
  const { isOther, user, logout } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!isOther || !user) return null;

  const handleLogout = async () => {
    try {
      setLoading(true);
      await logout();
    } catch (error) {
      console.error("Error al cerrar sesión alterna:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: DARK,
        px: 2,
        py: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: `2px solid ${GREEN}`,
      }}
    >
      <Typography sx={{ fontSize: 13, color: "#8899AA" }}>
        Sesión activa:{" "}
        <Box component="span" sx={{ color: "white", fontWeight: 600 }}>
          {user.email || user.phoneNumber}
        </Box>
      </Typography>
      <Button
        variant="contained"
        size="small"
        onClick={handleLogout}
        disabled={loading}
        sx={{
          bgcolor: GREEN,
          color: "white",
          fontWeight: 700,
          fontSize: 12,
          borderRadius: "50px",
          textTransform: "none",
          boxShadow: "none",
          px: 2,
          "&:hover": { bgcolor: "#00b048" },
        }}
      >
        {loading ? (
          <CircularProgress size={16} sx={{ color: "white" }} />
        ) : (
          "Cambiar sesión"
        )}
      </Button>
    </Box>
  );
};
